<template>
  <el-input v-model="model" v-bind="$props" type="text"
    ><template #append>{{ currencyName }}</template></el-input
  >
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: '0'
    },
    currencyName: {
      type: String,
      default: 'تومان'
    }
  },
  computed: {
    model: {
      get() {
        if (this.value == 0) return '0'
        return String(this.value)
          .replace(/\D/g, '')
          .replace(/^0+/, '')
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      set(value) {
        this.$emit('input', +value.replace(/\D/g, ''))
      }
    }
  }
}
</script>
